import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 1.2 },
  { title: 'Quantidade' },
  { title: 'Posição' },
  { title: 'Resultado' },
  { title: 'Rentabilidade' },
  { title: 'Valor atual' },
  { title: 'Preço médio' },
];
